// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"81735b3a","545":"9224bc0a"}[chunkId] + ".chunk.js";
};